module.exports = __webpack_public_path__ + "media/miniCart/images/mini-cart-8caa62cdb6d5f42678a108c9f08c3f12.png";